import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import { IChatGroup } from 'app/rest/effects/chats/group/types';
import { IChatGroups } from 'app/view/react_components/main/chatView/store/chatView/types';
import { chatGroupsSetAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatGroupsSetAction';
import { getChatGroups } from 'app/rest/effects/chats/group/api/getChatGroups';

export const loadChatGroups = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(getChatGroups()).then((boards: IChatGroup[]) => {
            const boardsObj: IChatGroups = {};
            boards.forEach((board: IChatGroup) => {
                boardsObj[board.id] = board;
            })
            dispatch(chatGroupsSetAction(boardsObj));
            return boards;
        });
    }
    return action;
}
